import { Navigate } from "react-router-dom";

import BaseLayout from "src/layouts/BaseLayout";
import SidebarLayout from "src/layouts/SidebarLayout";

import Dashboard from "src/views/pages/Dashboard";
import Captains from "src/views/pages/Captains";
import Parents from "src/views/pages/Parents";
// import Routes from "src/views/pages/Routes";
import Vehicles from "src/views/pages/Vehicles";
import Cameras from "src/views/pages/Cameras";
import Bookings from "src/views/pages/Bookings";
import Ratings from "src/views/pages/Ratings";
import Notifications from "src/views/pages/Notifications";
import Schools from "src/views/pages/Schools";

import Login from "src/views/session-pages/login";

const router = [
  {
    path: "/login",
    element: (
      <BaseLayout>
        <Login />
      </BaseLayout>
    )
  },

  {
    path: "/",
    element: <SidebarLayout />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "bookings", element: <Bookings /> },
      { path: "captains", element: <Captains /> },
      { path: "parents", element: <Parents /> },
      // { path: "routes", element: <Routes /> },
      { path: "vehicles", element: <Vehicles /> },
      { path: "cameras", element: <Cameras /> },
      { path: "ratings", element: <Ratings /> },
      { path: "schools", element: <Schools /> },
      { path: "notifications", element: <Notifications /> }
    ]
  },

  {
    path: "*",
    element: <Navigate to="/" replace />
  }
];

export default router;